import React from 'react';
import styled from 'styled-components';
import { compose, withProps, withHandlers } from 'recompose';
import { withToggle } from '../../hoc';
import { Portal } from '../atoms';
import { withRef } from '../../hoc/withRef';

const enchance = compose(
  withRef('rootEl'),
  withRef('menuEl'),
  withToggle(),
  withHandlers({
    handleClick: ({ toggle, toggled, getMenuEl }) => (event) => {
      event.stopPropagation();
      const menu = getMenuEl();

      if (!toggled) {
        toggle();
      }

      if (toggled && event.target.contains(menu)) {
        toggle();
      }
    },
    onClose: ({ hide }) => () => {
      hide();
    },
  }),
  withProps((p) => {
    const ref = p.getRootEl();
    if (!ref) return p;
    const offset = getGlobalOffset(ref);

    return {
      ...p,
      position: {
        top: offset.top + ref.clientHeight + 'px',
        left: offset.left + 'px',
        transform: `translateX(calc(-100% + ${ref.clientWidth}px))`,
      },
    };
  })
);

const MenuWithToggleView = ({
  toggled,
  position,
  button,
  render,
  rootEl,
  menuEl,
  handleClick,
  onClose,
  fade,
  hide,
}) => (
  <Container ref={rootEl}>
    {button(handleClick)}
    {toggled && (
      <Portal>
        <Fade visible={fade} onClick={hide} />
        <Menu ref={menuEl} position={position}>
          {render(onClose)}
        </Menu>
      </Portal>
    )}
  </Container>
);

const Container = styled.div`
  position: relative;
  display: inline-block;
  z-index: 2;
`;
const Fade = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: ${(p) => p.visible && 'rgba(0, 0, 0, 0.2)'};
  z-index: 1010;
`;
const Menu = styled.div`
  position: absolute;
  left: ${({ position }) => position.left};
  top: ${({ position }) => position.top};
  transform: ${({ position }) => position.transform};
  z-index: 1011;
`;

export const MenuWithToggle = enchance(MenuWithToggleView);

MenuWithToggle.defaultProps = {
  position: {
    left: 0,
    top: 0,
    transform: null,
  },
  button: () => {},
};

function getGlobalOffset(el) {
  var x = 0,
    y = 0;
  while (el) {
    x += el.offsetLeft;
    y += el.offsetTop;
    el = el.offsetParent;
  }
  return { left: x, top: y };
}
